var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24082 13.0174L15.9707 8.02913L10.9824 16.759C10.8965 16.9093 10.8542 17.0806 10.8601 17.2537C10.8661 17.4267 10.9201 17.5947 11.0162 17.7387L14.9135 23.5848C15.0104 23.73 15.146 23.8452 15.305 23.9171C15.464 23.9891 15.6401 24.0149 15.8131 23.9918C15.986 23.9686 16.1491 23.8973 16.2836 23.7861C16.4181 23.6749 16.5186 23.5281 16.5738 23.3625L23.9519 1.22736C24.0067 1.06308 24.0147 0.886781 23.9749 0.718233C23.9351 0.549685 23.8492 0.395546 23.7267 0.27309C23.6043 0.150635 23.4501 0.0647036 23.2816 0.0249273C23.113 -0.014849 22.9367 -0.00689802 22.7725 0.0478887L0.637559 7.42616C0.47196 7.48135 0.325181 7.58193 0.213925 7.71643C0.10267 7.85094 0.0314064 8.01397 0.0082449 8.18699C-0.0149166 8.36 0.010954 8.53604 0.0829126 8.69507C0.154871 8.8541 0.270028 8.98974 0.415277 9.08655L6.26135 12.9839C6.40542 13.0799 6.57335 13.1338 6.74633 13.1397C6.91932 13.1457 7.09055 13.1033 7.24082 13.0174Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfer);
export default __webpack_public_path__ + "static/media/icon-transfer.9f1591ec733681b8f412c005c27f1202.svg";
export { ForwardRef as ReactComponent };